import { adminInstance } from "@/api/instance";

export default async function (userId) {
  return adminInstance.get(`/user/${userId}`);
}
